import React from 'react';

import {graphQLToREST} from 'graphql-client/declarative-translations/external/translate';
import ConnectionSearchInput from 'instruments/connections/ConnectionSearchInput';
import {Equipment} from 'instruments/equipment/EquipmentConstants';
import {EquipmentEditableField} from 'instruments/equipment/EquipmentPicker';
import {getConnectionIdFromEquipment} from 'instruments/equipment/getConnectionIdFromEquipment';
import {keyToEmptyFilter, FilterKey} from 'search/SearchConstants';
import {Title} from 'ui-library/Headers';

// eslint-disable-next-line camelcase
import {RunQuery_run_RunNode_connection_ConnectionNode} from './__generated/RunQuery';

interface RunDataSourceSelectorProps {
  shouldRecordEquipment: boolean;
  selectedEquipment?: Equipment | null;
  onUpdateEquipment: (connectionId: string | null, equipmentId: string | null) => void;
  adapterId?: string;
  connectionSchemaId?: string;
  // eslint-disable-next-line camelcase
  connection: RunQuery_run_RunNode_connection_ConnectionNode | null;
  onUpdateConnection: (connectionId: string | null) => void;
  fieldEditable: boolean;
}

export function RunDataSourceSelector(props: RunDataSourceSelectorProps): JSX.Element | null {
  const {adapterId, connectionSchemaId, onUpdateEquipment} = props;
  const hasAdapter = Boolean(adapterId || connectionSchemaId);

  if (props.shouldRecordEquipment) {
    return (
      <>
        <Title>Equipment</Title>
        <div>
          <EquipmentEditableField
            initialSelection={
              props.selectedEquipment ? [graphQLToREST('BioentitySummary', props.selectedEquipment)] : []
            }
            onComplete={async (equipment) => {
              const connectionId = await getConnectionIdFromEquipment(equipment[0]?.id, adapterId);
              onUpdateEquipment(connectionId, equipment[0]?.id);
            }}
            shouldAllowMultiple={false}
            adapterId={adapterId}
            isWriteable={props.fieldEditable}
          />
        </div>
      </>
    );
  } else if (!props.shouldRecordEquipment && hasAdapter) {
    return (
      <>
        <Title>Connection</Title>
        <div>
          <ConnectionSearchInput
            autoFocus={false}
            selectedItems={props.connection ? [props.connection] : []}
            shouldAllowMultiple={false}
            isReadOnly={!props.fieldEditable}
            // TODO(BNCH-149217): Replace connectionSchemaId filter with adapter_id once it's in the
            // connection search index.
            extraFilters={
              connectionSchemaId
                ? [
                    {
                      ...keyToEmptyFilter(FilterKey.SCHEMA),
                      value: [connectionSchemaId],
                    },
                  ]
                : []
            }
            onChange={(connections) => {
              props.onUpdateConnection(connections[0]?.id);
            }}
          />
        </div>
      </>
    );
  } else {
    return null;
  }
}
